<template>
  <form
    ref="form"
    data-url="/accreditations/process/nonConformitiesEvaluation/updateCustom601"
    :class="{ 'loading-opacity': preloader }"
    enctype="multipart/form-data"
  >
    <div class="row">
      <div class="col-12">
        <legend>
          <p class="text-primary">Documentos anteriores</p>
        </legend>
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 25%"
                  >
                    USUARIO
                  </th>
                  <th scope="col" class="text-center" style="width: 15%">
                    FECHA DE CREACIÓN
                  </th>
                  <th scope="col" class="text-center" style="width: 10%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="accApp && accApp.request_signed">
                  <td class="align-middle">Solicitud de Acreditación</td>
                  <td class="align-middle text-center">
                    {{
                      accApp.request_signed.user
                        ? `${accApp.request_signed.user.first_name} ${accApp.request_signed.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ accApp.request_signed.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(accApp, 'request_signed')"
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <!-- <tr v-if="accApp">
                  <td class="align-middle">
                    Anexos de la Solicitud de Acreditación
                  </td>
                  <td class="align-middle text-center">
                    {{
                      accApp.user
                        ? `${accApp.user.first_name} ${accApp.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ accApp.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <a
                      class="btn btn-success"
                      :href="
                        `/accreditations/applications/${accApp.id}?tab=Anexos`
                      "
                      target="_blank"
                      ><app-icon name="file" /> {{ $t("view") }}</a
                    >
                  </td>
                </tr> -->
                <tr v-if="evalTest && evalTest.file_evaluation">
                  <td class="align-middle">Propuesta del Equipo Evaluador</td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.file_evaluation.user
                        ? `${evalTest.file_evaluation.user.first_name} ${evalTest.file_evaluation.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ evalTest.file_evaluation_date | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(evalTest, 'file_evaluation')"
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="evalTest && evalTest.sampling_plan_file">
                  <td class="align-middle">Plan de muestreo</td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.sampling_plan_file.user
                        ? `${evalTest.sampling_plan_file.user.first_name} ${evalTest.sampling_plan_file.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ evalTest.sampling_plan_file_date | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(evalTest, 'sampling_plan_file')"
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <!-- <tr v-if="evalTest && evalTest.risk_matrix">
                  <td class="align-middle">Matríz de riesgo</td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.risk_matrix.user
                        ? `${evalTest.risk_matrix.user.first_name} ${evalTest.risk_matrix.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ evalTest.risk_matrix.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(evalTest, 'risk_matrix')"
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr> -->
                <tr v-if="evalTest && evalTest.report_documentary_evaluation">
                  <td class="align-middle">Informe de Evaluación Documental</td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.report_documentary_evaluation.user
                        ? `${evalTest.report_documentary_evaluation.user.first_name} ${evalTest.report_documentary_evaluation.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.report_documentary_evaluation.created_at
                        | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'report_documentary_evaluation')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="evalTest && evalTest.first_instance_finding403">
                  <td class="align-middle">
                    (Evaluación Documental) Primera entrega - Informe para el
                    cierre de hallazgos y decisión
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.first_instance_finding403.user
                        ? `${evalTest.first_instance_finding403.user.first_name} ${evalTest.first_instance_finding403.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.first_instance_finding403.created_at | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'first_instance_finding403')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="evalTest && evalTest.request_additional_evidence">
                  <td class="align-middle">
                    (Evaluación Documental) Solicitud de Evidencias Adicionales
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.request_additional_evidence.user
                        ? `${evalTest.request_additional_evidence.user.first_name} ${evalTest.request_additional_evidence.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.request_additional_evidence.created_at
                        | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'request_additional_evidence')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="evalTest && evalTest.closing_finding_report">
                  <td class="align-middle">
                    (Evaluación Documental) Informe para el cierre de hallazgos
                    y decisión (Evaluador)
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.closing_finding_report.user
                        ? `${evalTest.closing_finding_report.user.first_name} ${evalTest.closing_finding_report.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.closing_finding_report.created_at | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'closing_finding_report')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="evalTest && evalTest.second_instance_finding403">
                  <td class="align-middle">
                    (Evaluación Documental) Segunda entrega - Informe para el
                    cierre de hallazgos y decisión
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.second_instance_finding403.user
                        ? `${evalTest.second_instance_finding403.user.first_name} ${evalTest.second_instance_finding403.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.second_instance_finding403.created_at
                        | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'second_instance_finding403')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="evalTest && evalTest.closing_finding_report_second">
                  <td class="align-middle">
                    (Evaluación Documental) 2do Informe para el cierre de
                    hallazgos y decisión (Evaluador)
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.closing_finding_report_second.user
                        ? `${evalTest.closing_finding_report_second.user.first_name} ${evalTest.closing_finding_report_second.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.closing_finding_report_second.created_at
                        | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'closing_finding_report_second')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="evalTest && evalTest.evaluation_plan_report">
                  <td class="align-middle">
                    (Evaluación InSitu / Remota) Plan de Evaluación
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.evaluation_plan_report.user
                        ? `${evalTest.evaluation_plan_report.user.first_name} ${evalTest.evaluation_plan_report.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.evaluation_plan_report.created_at | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'evaluation_plan_report')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <!-- <tr v-if="evalTest && evalTest.accepted_evaluation_plan">
                  <td class="align-middle">
                    (Evaluación InSitu / Remota) Plan de Evaluación (Aprobado
                    por el OEC)
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.accepted_evaluation_plan.created_at | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'accepted_evaluation_plan')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr> -->
                <tr
                  v-if="evalTest && evalTest.remote_in_situ_assessment_report"
                >
                  <td class="align-middle">
                    (Evaluación InSitu / Remota) Informe de Evaluación InSitu /
                    Remota
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.remote_in_situ_assessment_report.user
                        ? `${evalTest.remote_in_situ_assessment_report.user.first_name} ${evalTest.remote_in_situ_assessment_report.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.remote_in_situ_assessment_report.created_at
                        | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'remote_in_situ_assessment_report')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr
                  v-if="evalTest && evalTest.observation_plan_action"
                >
                  <td class="align-middle">
                    Observacion del plan de acción
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.observation_plan_action.user
                        ? `${evalTest.observation_plan_action.user.first_name} ${evalTest.observation_plan_action.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.observation_plan_action.created_at
                        | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'observation_plan_action')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr
                  v-if="evalTest && evalTest.report_plan_action"
                >
                  <td class="align-middle">
                    Informe para el cierre de No Conformidades de OEC y para la Decisión
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.report_plan_action.user
                        ? `${evalTest.report_plan_action.user.first_name} ${evalTest.report_plan_action.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.report_plan_action.created_at
                        | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'report_plan_action')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="evalTest && evalTest.testification_report">
                  <td class="align-middle">Informe de Testificación</td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.testification_report.user
                        ? `${evalTest.testification_report.user.first_name} ${evalTest.testification_report.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ evalTest.testification_report.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(evalTest, 'testification_report')"
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="evalTest && evalTest.findings_closing_report_603_first && inputs.version10 == 1">
                  <td class="align-middle">
                    Informe para el cierre de hallazgos evaluador
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.findings_closing_report_603_first.user
                        ? `${evalTest.findings_closing_report_603_first.user.first_name} ${evalTest.findings_closing_report_603_first.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.findings_closing_report_603_first.created_at
                        | dateFormat
                    }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(evalTest, 'findings_closing_report_603_first')
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
                <tr v-if="evalTest && evalTest.other_record506">
                  <td class="align-middle">Otro</td>
                  <td class="align-middle text-center">
                    {{
                      evalTest.other_record506.user
                        ? `${evalTest.other_record506.user.first_name} ${evalTest.other_record506.user.last_name}`
                        : ""
                    }}
                  </td>
                  <td class="align-middle text-center">
                    {{ evalTest.other_record506.created_at | dateFormat }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(evalTest, 'other_record506')"
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="col-12" v-if="evalTest && evalTest.request_additional_evidence_603">
        <legend>
          <p class="text-primary">Evidencias Adicionales.</p>
        </legend>
        <div class="row">
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col">NOMBRE</th>
                <th
                  scope="col"
                  class="align-middle text-center"
                  style="width: 25%"
                >
                  USUARIO
                </th>
                <th scope="col" class="text-center" style="width: 15%">
                  FECHA DE CREACIÓN
                </th>
                <th scope="col" class="text-center" style="width: 10%">
                  ACCIÓN
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="evalTest && evalTest.request_additional_evidence_603">
                <td class="align-middle">
                  (No Conformidades) Solicitud de Evidencias Adicionales
                </td>
                <td class="align-middle text-center">
                  {{
                    evalTest.request_additional_evidence_603.user
                      ? `${evalTest.request_additional_evidence_603.user.first_name} ${evalTest.request_additional_evidence_603.user.last_name}`
                      : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{
                    evalTest.request_additional_evidence_603.created_at
                      | dateFormat
                  }}
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(evalTest, 'request_additional_evidence_603')
                    "
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- <div class="col-12" v-if="showFileTemplate">
        <app-note
          class="mb-primary"
          :show-title="false"
          :notes="[
            'A continuación se muestra la plantilla editable para el informe de cierre de hallazgoz y decisión, que usted podrá descargarla y llenar la información de esta etapa',
          ]"
        />
      </div>
      <div class="col-12" v-if="showFileTemplate">
        <button
          type="button"
          class="btn btn-success"
          @click="openFilesTemplates()"
        >
          <app-icon name="file" />
          Descargar
        </button>
      </div> -->

      <div class="col-12 mt-2">
        <app-note
          class="mb-primary"
          :show-title="false"
          :notes="['Todos los campos con un (*) son obligatorios.']"
        />
      </div>

      <div class="col-sm-6">
        <legend>
          <p class="text-primary">Documentación primera entrega</p>
        </legend>
        <div class="form-group">
          <label
            >Informe para el cierre de hallazgos y decisión
            <b class="text-danger ml-2" style="font-size: 18px !important"
              >*</b
            ></label
          >
          <!-- <app-input
            type="file"
            :label="inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')"
            v-model="inputs.file_1"
            :required="!inputs.extension_601"
            v-if="!inputs.first_instance_finding601"
            v-on:change="fileChoosen($event, 'file_1')"
          /> -->
          <app-input
            type="file"
            :label="inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')"
            v-model="inputs.file_1"
            v-if="!inputs.first_instance_finding601"
            v-on:change="fileChoosen($event, 'file_1')"
          />
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'first_instance_finding601')"
              v-if="inputs.first_instance_finding601"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <span v-if="inputs.version10 == 0"><button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('first_instance_finding601')"
              v-if="
                inputs.first_instance_finding601 &&
                  !evalTest.request_additional_evidence_603
              "
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button></span>
            <span v-if="inputs.version10 == 1"><button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('first_instance_finding601')"
              v-if="
                inputs.first_instance_finding601 &&
                (evalTest.task_time_interval_601 < 1)
              "
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button></span>
          </div>
        </div>
      </div>

    </div>

    <div class="row mt-2">
      <div class="col-12">
        <legend class="text-primary">
          Respaldo informe para el cierre de hallazgos y decisión primera
          entrega.
        </legend>
        <div
          class="card-body"
          v-if="evalTest && !evalTest.request_additional_evidence_603 && inputs.version10 == 0"
        >
          <div class="form-group">
            <app-input type="dropzone" v-model="files_1" />
            <p class="text-center text-danger mt-2">
              <small>
                <strong>Tamaño máximo de cada archivo 20MB</strong>
              </small>
            </p>
          </div>
        </div>
        <div
          class="card-body"
          v-if="evalTest && (evalTest.task_time_interval_601 < 1) && inputs.version10 == 1"
        >
          <div class="form-group">
            <app-input type="dropzone" v-model="files_1" />
            <p class="text-center text-danger mt-2">
              <small>
                <strong>Tamaño máximo de cada archivo 20MB</strong>
              </small>
            </p>
          </div>
        </div>
        <table class="table table-sm table-striped mt-2">
          <thead>
            <tr>
              <th scope="col">Nombre del documento</th>
              <th scope="col" class="text-center" style="width: 10%">
                Opciones
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(value,
              key) in inputs.support_management_non_conformities_601_1"
              :key="key"
            >
              <td class="align-middle">
                <small class="text-primary">{{
                  value.path.split("/")[value.path.split("/").length - 1]
                }}</small>
              </td>
              <td class="align-middle text-center">
                <div class="mt-2">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(
                        inputs.support_management_non_conformities_601_1,
                        key
                      )
                    "
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row" v-if="evalTest.request_additional_evidence_603 && inputs.version10 == 0">
      <div class="col-12 col-md-6">
        <legend>
          <p class="text-primary">
            Documentación primera entrega de evidencia adicional
          </p>
        </legend>
        <div class="form-group">
          <label
            >Informe para el cierre de hallazgos y decisión primera evidencia
            adicional
            <b class="text-danger ml-2" style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="file"
            :label="inputs.file_2 ? inputs.file_2.name : $t('upload_your_file')"
            v-model="inputs.file_2"
            :required="!inputs.extension_601"
            v-if="!inputs.second_instance_finding601"
            v-on:change="fileChoosen($event, 'file_2')"
          />
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'second_instance_finding601')"
              v-if="inputs.second_instance_finding601"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('second_instance_finding601')"
              v-if="
                inputs.second_instance_finding601 &&
                  !evalTest.findings_closing_report_603_second
              "
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
        <div class="col-12">
          <app-note
              class="mb-primary"
              title="Nota"
              content-type="html"
              :notes="[
              'Solo se aceptan archivos de tipo word: .doc, .docx'
        ]"
          />
        </div>
      </div>

    </div>

    <div class="row" v-if="(evalTest.task_time_interval_601 == 1) && inputs.version10 == 1">
      <div class="col-12 col-md-6">
        <legend>
          <p class="text-primary">
            Documentación primera entrega de evidencia adicional
          </p>
        </legend>
        <div class="form-group">
          <label
            >Informe para el cierre de hallazgos y decisión primera evidencia
            adicional
            <b class="text-danger ml-2" style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="file"
            :label="inputs.file_2 ? inputs.file_2.name : $t('upload_your_file')"
            v-model="inputs.file_2"
            :required="!inputs.extension_601"
            v-if="!inputs.second_instance_finding601"
            v-on:change="fileChoosen($event, 'file_2')"
          />
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'second_instance_finding601')"
              v-if="inputs.second_instance_finding601"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('second_instance_finding601')"
              v-if="
                inputs.second_instance_finding601 &&
                  !evalTest.findings_closing_report_603_second
              "
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
        <div class="col-12">
          <app-note
              class="mb-primary"
              title="Nota"
              content-type="html"
              :notes="[
              'Solo se aceptan archivos de tipo word: .doc, .docx'
        ]"
          />
        </div>
      </div>

    </div>

    <div class="row mt-2" v-if="evalTest.request_additional_evidence_603 && inputs.version10 == 0">
      <div class="col-12">
        <legend class="text-primary">
          Respaldo informe para el cierre de hallazgos y decisión primera
          entrega de evidencia adicional
        </legend>
        <div
          class="card-body"
          v-if="!evalTest.findings_closing_report_603_second"
        >
          <div class="form-group">
            <app-input type="dropzone" v-model="files_2" />
            <p class="text-center text-danger mt-2">
              <small>
                <strong>Tamaño máximo de cada archivo 20MB</strong>
              </small>
            </p>
          </div>
        </div>
        <table class="table table-sm table-striped mt-2">
          <thead>
            <tr>
              <th scope="col">Nombre del documento</th>
              <th scope="col" class="text-center" style="width: 10%">
                Opciones
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(value,
              key) in inputs.support_management_non_conformities_601_2"
              :key="key"
            >
              <td class="align-middle">
                <small class="text-primary">{{
                  value.path.split("/")[value.path.split("/").length - 1]
                }}</small>
              </td>
              <td class="align-middle text-center">
                <div class="mt-2">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(
                        inputs.support_management_non_conformities_601_2,
                        key
                      )
                    "
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row mt-2" v-if="(evalTest.task_time_interval_601 == 1) && inputs.version10 == 1">
      <div class="col-12">
        <legend class="text-primary">
          Respaldo informe para el cierre de hallazgos y decisión primera
          entrega de evidencia adicional
        </legend>
        <div
          class="card-body"
          v-if="!evalTest.findings_closing_report_603_second"
        >
          <div class="form-group">
            <app-input type="dropzone" v-model="files_2" />
            <p class="text-center text-danger mt-2">
              <small>
                <strong>Tamaño máximo de cada archivo 20MB</strong>
              </small>
            </p>
          </div>
        </div>
        <table class="table table-sm table-striped mt-2">
          <thead>
            <tr>
              <th scope="col">Nombre del documento</th>
              <th scope="col" class="text-center" style="width: 10%">
                Opciones
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(value,
              key) in inputs.support_management_non_conformities_601_2"
              :key="key"
            >
              <td class="align-middle">
                <small class="text-primary">{{
                  value.path.split("/")[value.path.split("/").length - 1]
                }}</small>
              </td>
              <td class="align-middle text-center">
                <div class="mt-2">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(
                        inputs.support_management_non_conformities_601_2,
                        key
                      )
                    "
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      class="row"
      v-if="showSecondEvidenceDoc"
    >
      <div class="col-12 col-md-6" v-if="showSecondEvidenceDoc">
        <legend>
          <p class="text-primary">
            Documentación segunda entrega de evidencia adicional
          </p>
        </legend>
        <div class="form-group">
          <label
            >Informe para el cierre de hallazgos y decisión segunda evidencia
            adicional
            <b class="text-danger ml-2" style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="file"
            :label="inputs.file_3 ? inputs.file_3.name : $t('upload_your_file')"
            v-model="inputs.file_3"
            :required="!inputs.extension_601"
            v-if="!inputs.third_instance_finding601"
            v-on:change="fileChoosen($event, 'file_3')"
          />
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'third_instance_finding601')"
              v-if="inputs.third_instance_finding601"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('third_instance_finding601')"
              v-if="inputs.third_instance_finding601"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <app-note
            class="mb-primary"
            title="Nota"
            content-type="html"
            :notes="[
              'Solo se aceptan archivos de tipo word: .doc, .docx'
        ]"
        />
      </div>
    </div>


    <div
      class="row mt-2"
      v-if="
        evalTest.request_additional_evidence_603 
      "
    >
      <div class="col-12" v-if="showSecondEvidenceDoc">
        <legend class="text-primary">
          Respaldo informe para el cierre de hallazgos y decisión segunda
          entrega de evidencia adicional
        </legend>
        <div class="card-body">
          <div class="form-group">
            <app-input type="dropzone" v-model="files_3" />
            <p class="text-center text-danger mt-2">
              <small>
                <strong>Tamaño máximo de cada archivo 20MB</strong>
              </small>
            </p>
          </div>
        </div>
        <table class="table table-sm table-striped mt-2">
          <thead>
            <tr>
              <th scope="col">Nombre del documento</th>
              <th scope="col" class="text-center" style="width: 10%">
                Opciones
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(value,
              key) in inputs.support_management_non_conformities_601_3"
              :key="key"
            >
              <td class="align-middle">
                <small class="text-primary">{{
                  value.path.split("/")[value.path.split("/").length - 1]
                }}</small>
              </td>
              <td class="align-middle text-center">
                <div class="mt-2">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(
                        inputs.support_management_non_conformities_601_3,
                        key
                      )
                    "
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- <div class="row" v-if="!inputs.extend_time_601"> -->
    <div class="row" v-if="showTimeA">
      <div class="col-12">
        <legend>
          <p class="text-primary">Solicitar extensión de tiempo</p>
        </legend>
        <div class="form-group">
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="radio-buttons"
            v-model="inputs.extension_601"
            :list="list"
          />
        </div>
      </div>
      <div class="col-sm-6" v-if="inputs.extension_601">     
        <div class="form-group">
          <label v-if="inputs.version10 == 0">Solicitud de extensión de tiempo
            <b class="text-danger ml-2" style="font-size: 18px !important">*</b>
          </label>
          <label v-if="inputs.version10 == 1">Justificación por casos de fuerza mayor o fortuito
            <b class="text-danger ml-2" style="font-size: 18px !important">*</b>
          </label>
      
          <app-input
              type="file"
              :label="inputs.file_4 ? inputs.file_4.name : $t('upload_your_file')"
              v-model="inputs.file_4"
              :required="true"
              v-if="!inputs.extension_time601"
            />
            <p class="text-danger" v-if="!inputs.extension_time601">
              No se autorizará prórrogas para la entrega del Plan de Acción, así como las evidencias de implementación, salvo en casos de fuerza mayor o fortuitos amparados por la Ley y normativa vigente aplicable, lo cual debe justificar el OEC por escrito mediante oficio y enviarlo al Director de Área
            </p>
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'extension_time601')"
              v-if="inputs.extension_time601"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('extension_time601')"
              v-if="inputs.extension_time601"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>     
      </div>
    </div>

    <!-- <div class="row">
      <div class="col-12 mt-2" >
        <legend class="text-primary">Sección Quejas</legend>

        <label>¿Existe alguna Queja?</label>
        <app-input
          type="radio-buttons"
          v-model="inputs.exist_complaint"
          :list="confirm"
        />
        <div class="col-md-6 mt-2" v-if="inputs.exist_complaint">
          <div class="form-group">
            <label for="reason"
              >Motivo <span class="color_import">*</span></label
            >
            <app-input
              id="inputs_name"
              type="select"
              v-model="inputs.reason_complaint_id"
              :list="[
                { id: '', value: this.$t('select_option') },
                ...reasonList,
              ]"
              :required="true"
            />
          </div>
        </div>
        <div class="col-md-6 mt-2" v-if="inputs.exist_complaint">
          <div class="form-group">
            <label
              >Documento de la Queja <span class="color_import">*</span></label
            >
            <app-input
              type="file"
              :label="
                inputs.file_c ? inputs.file_c.name : $t('upload_your_file')
              "
              v-model="inputs.file_c"
              :required="true"
              v-if="!inputs.complaint_document_oec"
            />
          </div>
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'complaint_document_oec')"
              v-if="inputs.complaint_document_oec"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('complaint_document_oec')"
              v-if="inputs.complaint_document_oec"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>
    </div> -->
    <hr/>
    <div class="alert alert-warning col-12" role="alert">
      Después de <b>Guardar</b> deberá <b>Procesar</b> el registro
    </div>
    <div class="row">
      <div class="col-12 mt-3">
        <button
          type="submit"
          class="btn btn-primary mr-2"
          @click.prevent="submit"
        >
          {{ $t("save") }}
        </button>
        <button
            type="button"
            class="btn btn-success btn-with-shadow ml-3"
            @click="openDeleteModalProccess"
          >
            Procesar
          </button>
      </div>
    </div>

    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea eliminar este archivo?"
    />

    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="confirmedProccess"
      @cancelled="cancelledProccess"
      title="POR FAVOR ASEGÚRESE DE CARGAR EL FORMATO VIGENTE, QUE LO PUEDE ENCONTRAR  EN LA PARTE SUPERIOR DE ESTA INTERFAZ"
      message="¿Desea procesar este registro?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { axiosPost } from "@/app/helpers/AxiosHelper";
//import * as actions from "../../../../apiUrl";

export default {
  mixins: [FormMixin],

  data() {
    return {
      preloader: false,
      inputs: {
        exist_complaint: 0,
        support_management_non_conformities_601_1: [],
        support_management_non_conformities_601_2: [],
        support_management_non_conformities_601_3: [],
      },
      showFileTemplate: false,
      showSecondEvidenceDoc: false, 
      path_non_file: "",
      deleteModal: false,
      selected: "",
      observation: "",
      files_1: [],
      files_2: [],
      files_3: [],
      list: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
      confirm: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      reasonList: [],
      dateComplaint: "",
      section_complaint: false,
      requiredReason: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      showTimeA: true,
    };
  },

  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview.evalTest
        ? this.$store.state.evaluatorReview.evalTest
        : {};
    },

    accApp() {
      return this.evalTest ? this.evalTest.accreditation_applications : null;
    },

    rejectCounter() {
      return this.$store.state.evaluatorReview.evalTest
        ? this.$store.state.evaluatorReview.evalTest
            .corrective_actions_reject_counter == 0
        : true;
    },
  },

  watch: {
    "$store.state.evaluatorReview.evalTest": function() {
      this.loadForm();
    },

    "inputs.extension_601": function() {
      if (this.inputs.extension_601 == 1) {
        this.inputs.file_1 = null;
        this.files_1 = [];
        this.inputs.file_2 = null;
        this.files_2 = [];
        this.inputs.file_3 = null;
        this.files_3 = [];
      }
    },
  },

  filters: {
    dateFormat: function(value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },

  created() {
    this.openFilesTemplatesCharge();
    this.loadForm();
    // this.openComplaintSection();
  },

  methods: {
    beforeSubmit() {
      this.preloader = true;
      if (this.inputs.exist_complaint) {
        this.requiredReason = true;
      }
    },
    fileChoosen(event, key) {
      const type1 = 'application/msword';
      const type2 = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      if (event.target.files[0].type === type1 ||
          event.target.files[0].type === type2) {
         //To do something
      }else{
        this.$toastr.e("Solo se permite archivos de word: .doc, .docx");
        this.inputs[key] = null;
      }
    },
    submit() {
      if (this.files_1.length > 0 && this.validateFileSize(this.files_1) > 0) {
        this.$toastr.e("El tamaño maximo permitido de cada archivo es de 20MB");
        return;
      }

      if (this.files_2.length > 0 && this.validateFileSize(this.files_2) > 0) {
        this.$toastr.e("El tamaño maximo permitido de cada archivo es de 20MB");
        return;
      }

      if (this.files_3.length > 0 && this.validateFileSize(this.files_3) > 0) {
        this.$toastr.e("El tamaño maximo permitido de cada archivo es de 20MB");
        return;
      }

      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }

      this.files_1.forEach((file) => {
        formData.append("files_1[]", file);
      });

      this.files_2.forEach((file) => {
        formData.append("files_2[]", file);
      });

      this.files_3.forEach((file) => {
        formData.append("files_3[]", file);
      });

      this.save(formData);
    },

    afterSuccess({ data: { data } }) {
      this.$store.state.evaluatorReview.evalTest = data;
      this.$toastr.s(this.$t("updated_success"));
      this.files_1 = [];
      this.files_2 = [];
      this.files_3 = [];
      this.requiredReason = false;
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    openDeleteModal(fileName) {
      this.selected = fileName;
      this.deleteModal = true;
    },

    confirmed() {
      this.inputs[this.selected] = null;
    },

    observationList() {},

    cancelled() {
      this.deleteModal = false;
    },

    openTab(obj, fileName) {
      let info = {};
      info['accAppId'] = null;
      info['evalTestId'] = this.$store.state.evaluatorReview.evalTest.id;
      info['path'] = String(obj[fileName].path);
      this.$store.dispatch("registerFileLog", info);
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    loadForm() {
      if (this.$store.state.evaluatorReview.evalTest) {
        this.inputs = {
          evalTestId: this.$store.state.evaluatorReview.evalTest.id,
          third_instance_finding601: this.$store.state.evaluatorReview.evalTest
            .third_instance_finding601,
          second_instance_finding601: this.$store.state.evaluatorReview.evalTest
            .second_instance_finding601,
          first_instance_finding601: this.$store.state.evaluatorReview.evalTest
            .first_instance_finding601,
          support_management_non_conformities_601_1: this.$store.state
            .evaluatorReview.evalTest.support_management_non_conformities_601_1,
          support_management_non_conformities_601_2: this.$store.state
            .evaluatorReview.evalTest.support_management_non_conformities_601_2,
          support_management_non_conformities_601_3: this.$store.state
            .evaluatorReview.evalTest.support_management_non_conformities_601_3,
          complaint_document_oec:
            this.$store.state.evaluatorReview.evalTest.complaint_document_oec,
          exist_complaint:
            this.$store.state.evaluatorReview.evalTest.exist_complaint,
          reason_complaint_id:
            this.$store.state.evaluatorReview.evalTest.reason_complaint_id,
          extension_time601: this.$store.state.evaluatorReview.evalTest
            .extension_time601,
          extension_601: this.$store.state.evaluatorReview.evalTest
            .extension_601,
          extend_time_601: this.$store.state.evaluatorReview.evalTest
            .extend_time_601,
          version10: this.$store.state.evaluatorReview.evalTest.accreditation_applications.revision_v10 ? 1: 0
        };

        if (this.$store.state.evaluatorReview.evalTest.task_time_interval_601 == 0 && this.$store.state.evaluatorReview.evalTest.show_timea) {
          this.showTimeA = false;
        }

        if (this.$store.state.evaluatorReview.evalTest.task_time_interval_601 == 1 && this.$store.state.evaluatorReview.evalTest.show_timeb) {
          this.showTimeA = false;
        }

        if (this.$store.state.evaluatorReview.evalTest.task_time_interval_601 == 2 && this.$store.state.evaluatorReview.evalTest.show_timec) {
          this.showTimeA = false;
        }

        if(this.$store.state.evaluatorReview
              .evalTest.findings_closing_report_603_second){
          this.showSecondEvidenceDoc = true; 
        }
      }
    },

    validateFileSize(files) {
      return files.filter((file) => {
        if (file.size > 25000000) {
          return file;
        }
      }).length;
    },

    openFilesTemplates() {
      const w = window.open(this.path_non_file, "_blank");
      w.focus();
    },

    openFilesTemplatesCharge() {
      // consultar el template activo
      let urlNon = `non-conformities-template/infoActiveTemplate`;
      this.axiosGet(urlNon)
        .then((response) => {
          if (response.data.path != undefined) {
            this.showFileTemplate = true;
            this.path_non_file = response.data.path;
          }
        })
        .catch((error) => {
          console.log(error);
        });
        let reasonUrl = `accreditations/process/nonConformitiesEvaluation/reasonComplaintList`;
      this.axiosGet(reasonUrl).then((response) => {
        this.reasonList = response.data;
      });
    },

    openComplaintSection() {
      var id = localStorage.getItem("evalId");
      let dateUrl = `accreditations/process/nonConformitiesEvaluation/validateComplaint/${id}`;
      this.axiosGet(dateUrl).then((response) => {
        this.dateComplaint = response.data;
        if (this.dateComplaint) {
          this.section_complaint = true;
          console.log("True");
        } else {
          this.section_complaint = false;
          console.log("False");
        }
      });
    },
    openDeleteModalProccess() {
      this.deleteConfirmationModalActive = true;
    },
    confirmedProccess() {
      this.deleteLoader = true;
      const url = `/accreditations/process/nonConformitiesEvaluation/process?evalTestId=${this.$store.state.evaluatorReview.evalTest.id}`;
      const data = {
        additional_evidence: this.additional_evidence,
        corrective_actions_reject_counter: this.$store.state.evaluatorReview
          .evalTest.corrective_actions_reject_counter,
      };
      axiosPost(url, data)
        .then(({ data: res }) => {
          this.deleteLoader = false;
          $("#modal-confirm-id").modal("hide");
          this.cancelledProccess();
          if (res.data === "OK") {
            this.$toastr.s("Registro procesado con exito");
            this.returnPage();
          } else {
            this.$toastr.e(res.data);
          }
        })
        .catch(({ error }) => {});
    },
    cancelledProccess() {
      this.deleteConfirmationModalActive = false;
    },
    returnPage() {
      window.location.href = `/accreditations/process/nonConformitiesEvaluation/?tab=Reportar%20Acciones%20Correctivas`;
    },
  },
};
</script>
<style>
.color_import {
  color: #ff5733;
  font-weight: bolder;
}
</style>
